import { FC } from 'react'
import '@/styles/globals.css'
// UI package styles, make sure its imported after this project's global css so that style css can override it
import '@saasalerts/ui/style.css'
import '@/utils/firebaseClient'
import { SWRConfig } from 'swr'
import fetch from '@/utils/fetchJson'
import { Toaster } from 'react-hot-toast'
import type { AppProps } from 'next/app'
import { AuthenticationGuard } from '@/components/AuthenticationGuard'
import { AuthorizationGuard } from '@/components/AuthorizationGuard'
import { AppHead } from '@/components/Layout'
import { SessionTimeout } from '@/components/Modals/SessionTimeout'
import { ThemeProvider } from '@/contexts/ThemeContext'
import { PagesProgressProvider as ProgressProvider } from '@bprogress/next'
import { LicenseScopeProvider } from '@/contexts/LicenseScopeContext'
import { waitForMeticulous } from '@/utils/meticulous'

if (typeof window !== 'undefined') void waitForMeticulous()

const Noop: FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <>{children}</>
)

// function indexedDBProvider() {
//   const map = new Map<string, any>()

//   const request = indexedDB.open('app-cache', 1)

//   request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
//     // @ts-ignore
//     const db = event.target?.result as IDBDatabase
//     db.createObjectStore('cache')
//   }

//   request.onsuccess = () => {
//     const db = request.result
//     const tx = db.transaction('cache', 'readonly')
//     const store = tx.objectStore('cache')

//     // Load existing data from IndexedDB to the memory map
//     const getAllRequest = store.getAll()
//     getAllRequest.onsuccess = (event: Event) => {
//       const data = (event.target as IDBRequest).result as [string, any][]
//       data.forEach(([key, value]) => {
//         map.set(key, value)
//       })
//     }

//     // Before unloading the app, write back all the data into IndexedDB
//     window.addEventListener('beforeunload', () => {
//       const tx = db.transaction('cache', 'readwrite')
//       const store = tx.objectStore('cache')
//       Array.from(map.entries()).forEach(([key, value]) => {
//         store.put(value, key)
//       })
//     })
//   }

//   return map
// }

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function MyApp({ Component, pageProps }: AppProps) {
  // @ts-ignore - Diff to add type of Layout in Component
  const Layout = Component.Layout || Noop

  return (
    <ProgressProvider
      height="3px"
      color="var(--progress-color)"
      options={{ showSpinner: false }}
      shallowRouting
    >
      <ThemeProvider>
        <LicenseScopeProvider initialLicenseScope={pageProps.licenseScope}>
          <SWRConfig
            value={{
              // provider: indexedDBProvider,
              fetcher: fetch,
              shouldRetryOnError: false,
              revalidateOnFocus: false,
            }}
          >
            <div>
              <AppHead />
              <AuthenticationGuard>
                <AuthorizationGuard>
                  <Layout>
                    <Component {...pageProps} />
                  </Layout>
                </AuthorizationGuard>
              </AuthenticationGuard>
              <SessionTimeout />
              <Toaster position="bottom-center" />
            </div>
          </SWRConfig>
        </LicenseScopeProvider>
      </ThemeProvider>
    </ProgressProvider>
  )
}

export default MyApp
